
import {api} from '@/constants'
import {partnersForm} from '@/constants'
import BaseInput from "@/components/base/BaseInput.vue";
import BaseCustomTelInput from "@/components/base/BaseCustomTelInput.vue";
import BaseTextArea from "@/components/base/BaseTextArea.vue";
import CongratulationBlock from "@/components/getInTouch/CongratulationBlock.vue";

export default {
  components: {
    BaseInput,
    BaseTextArea,
    CongratulationBlock,
    BaseCustomTelInput
  },
  data() {
    return {
      partnersForm,
      form: {},
      errors: {},
      fields: [],
      isFilled: false,
      isCorrect: false,
      phoneError: false,
      emailError: false
    }
  },
  mounted() {
    this.fields = partnersForm.map(item => item.name);
  },
  methods: {
    async sendContact() {
      if(!this.checkPhoneNumber()) {
        this.phoneError = true
        this.$refs.phoneNumber[0].$el.lastChild.classList.add('err-border')
        return
      } else {
        this.phoneError = false
      }

      if(!this.checkEmail()) {
        this.emailError = true
        this.$refs.email[0].$el.lastChild.classList.add('err-border')
        return
      } else {
        this.emailError = false
      }

      this.$refs.phoneNumber[0].$el.lastChild.classList.remove('err-border')
      this.$refs.email[0].$el.lastChild.classList.remove('err-border')
      this.$route.path.includes('forartists') ? this.form['tArtists'] = '1' : ''
      await this.$axios.$post(api.PARTNERS_API + '/web/partner?form=mx', this.form, {
        headers: {
          'content-type': 'application/json'
        }
      }).then((res) => {
        if (res.status === 'OK') this.isFilled = true
      }).catch(error => {
        throw new Error(error)
      })
    },
    handleInput() {
      this.isCorrect = this.fields.every(field => {
          return this.form[field] && this.form[field].trim() !== '';
      });
    },
    checkPhoneNumber() {
      return this.form['phoneNumber'] && /^\d{1,12}$/.test(this.form['phoneNumber']);
    },
    checkEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return this.form['email'] && emailRegex.test(this.form['email']);
    },
    removeError(data) {
      delete this.errors[data]
    }
  }
}
